<template>
    <cus-dialog :visible.sync="visibleSync" title="时间调整" :timedata="timedataSync" width="40%" @confirm="saveTime()">
        <div v-wechat-title="title">
            <div>
                <el-input ref="eventyear" :maxlength="4" class="inputStyle" v-model="eventyear" @input="changeYearNum" @focus="setrefsIndex(`eventyear`)" @keyup.native="keyupChange"></el-input>年
                <el-input ref="eventmonth" :maxlength="2" class="inputStyle" v-model="eventmonth" @input="changeMonthNum" @focus="setrefsIndex(`eventmonth`)" @keyup.native="keyupChange"></el-input>月
                <el-input ref="eventdate" :maxlength="2" class="inputStyle" v-model="eventdate" @input="changeDateNum" @focus="setrefsIndex(`eventdate`)" @keyup.native="keyupChange"></el-input>日
                <el-input ref="eventhours" :maxlength="2" class="inputStyle" v-model="eventhours" @input="changeHoursNum" @focus="setrefsIndex(`eventhours`)" @keyup.native="keyupChange"></el-input>:
                <el-input
                    ref="eventminutes"
                    :maxlength="2"
                    class="inputStyle"
                    v-model="eventminutes"
                    @input="changeMinutesNum"
                    @focus="setrefsIndex(`eventminutes`)"
                    @keyup.native="keyupChange"
                ></el-input>
            </div>
        </div>
    </cus-dialog>
</template>
<script>
export default {
    name: `DateTimeInput`,
    props: {
        surgeryid: String,
        visible: { type: Boolean, default: () => false },
        eventid: String,
        timedata: { type: String }
    },
    data() {
        return {
            title: `时间调整`,
            eventtime: new Date(),
            eventyear: ``,
            eventmonth: ``,
            eventdate: ``,
            eventhours: ``,
            eventminutes: ``,
            msg: `closeWindow`,
            data: {},
            refsIndex: null
        }
    },
    created() {

    },
    computed: {
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        timedataSync: {
            get: function() {
                this.LoadTime()
                return this.timedata
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
        // timedata2 {
        //     get: function() {
        //         return this.timedata
        //     },
        //     set: function(newval) {
        //         this.$emit(`update:visible`, newval)
        //     }
        // }
    },
    mounted() {
    },
    methods: {
        setrefsIndex(index) {
            this.refsIndex = index
        },
        changeYearNum(e) {
            let value = e.replace(/[^\d]/g, ``)
            if (parseInt(value) < 1) {
                value = 1
            }
            // value = (`0000` + value).substr(-4)
            this.eventyear = value
        },
        changeMonthNum(e) {
            let value = e.replace(/[^\d]/g, ``)
            if (parseInt(value) > 12) {
                value = `01`
            }
            // value = (`00` + value).substr(-2)
            this.eventmonth = value
        },
        changeDateNum(e) {
            let value = e.replace(/[^\d]/g, ``)
            if (parseInt(value) > 31) {
                value = `01`
            }
            // value = (`00` + value).substr(-2)
            this.eventdate = value
        },
        changeHoursNum(e) {
            let value = e.replace(/[^\d]/g, ``)
            // value = (`00` + value).substr(-2)
            if (parseInt(value) >= 24) {
                value = `00`
            }
            this.eventhours = value
            if (value.length == 2 && parseInt(value) <= 24) {
                this.$refs.eventminutes.focus()
            }
        },
        changeMinutesNum(e) {
            let value = e.replace(/[^\d]/g, ``)
            // value = (`00` + value).substr(-2)
            if (parseInt(value) >= 60) {
                value = `00`
            }
            this.eventminutes = value
        },
        keyupChange(e) {
            let strlen = e.srcElement.value.toString().length
            // let selectionStart = e.srcElement.selectionStart
            var that = this
            if (e.keyCode !== 37 && e.keyCode !== 38 && e.keyCode !== 39 && e.keyCode !== 40) {
                return
            }
            // 左箭头
            if (e.keyCode == 37) {
                switch (that.refsIndex) {
                // case `eventyear`:
                //     that.$refs.eventyear.focus()
                //     break
                case `eventmonth`:
                    that.$refs.eventyear.focus()
                    break
                case `eventdate`:
                    that.$refs.eventmonth.focus()
                    break
                case `eventhours`:
                    that.$refs.eventdate.focus()
                    break
                case `eventminutes`:
                    that.$refs.eventhours.focus()
                    break
                default:
                    break
                }
            }
            // 上箭头
            if (e.keyCode == 38) {
                switch (that.refsIndex) {
                case `eventhours`:
                    if (that.eventhours < 23) {
                        that.eventhours += 1
                    }
                    break
                case `eventminutes`:
                    if (that.eventhours < 59) {
                        that.eventminutes += 1
                    }
                    break
                default:
                    break
                }
            }
            // 右箭头
            if (e.keyCode == 39) {
                switch (that.refsIndex) {
                case `eventyear`:
                    that.$refs.eventmonth.focus()
                    break
                case `eventmonth`:
                    that.$refs.eventdate.focus()
                    break
                case `eventdate`:
                    that.$refs.eventhours.focus()
                    break
                case `eventhours`:
                    that.$refs.eventminutes.focus()
                    break
                    // case `eventminutes`:
                    //     that.$refs.eventminutes.focus()
                    //     break
                default:
                    break
                }
            }
            // 下箭头
            if (e.keyCode == 40) {
                switch (that.refsIndex) {
                case `eventhours`:
                    if (that.eventhours > 0) {
                        that.eventhours = that.eventhours - 1
                    }
                    break
                case `eventminutes`:
                    if (that.eventhours > 0) {
                        that.eventminutes = that.eventminutes - 1
                    }
                    break
                default:
                    break
                }
            }
            setTimeout(() => {
                e.srcElement.selectionStart = e.srcElement.selectionEnd = strlen
            }, 1)
        },
        LoadTime() {
            this.eventtime = this.$moment(this.timedata).format(`YYYY/MM/DD HH:mm`)
            this.eventtime = new Date(this.eventtime)
            this.eventyear = this.eventtime.getFullYear()
            this.eventmonth = this.eventtime.getMonth() + 1
            this.eventdate = this.eventtime.getDate()
            this.eventhours = this.eventtime.getHours()
            this.eventminutes = this.eventtime.getMinutes()
        },
        saveTime() {
            let eventtime = this.eventyear + `/` + this.eventmonth + `/` + this.eventdate + ` ` + this.eventhours + `:` + this.eventminutes
            console.log(eventtime)
            this.$emit(`changetime`, eventtime)
            // return new Promise(resolve => {
            //     let req = that.myaxios.get(`/api/Intraoperative/Anaesthesia/SaveOccurEventByEventid?surgeryid=${this.surgeryid}&eventid=${this.eventid}&occurtime=${eventtime}`)
            //     req.then(data => {
            //         that.data = data
            //         that.msg = `ok`
            //         that.sendMessage()
            //     }).catch(e => {
            //         console.log(e)
            //         if (this.surgeryid && this.eventid) {
            //             this.$message.error(`时间格式不正确！`)
            //         }
            //     })
            // })
        }
    },
    watch: {}
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
.inputStyle {
    width: 65px !important;
}
</style>



// WEBPACK FOOTER //
// src/common/DateTimeInput.vue